"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/web.atob.js");

require("core-js/modules/web.dom-exception.constructor.js");

require("core-js/modules/web.dom-exception.stack.js");

require("core-js/modules/web.dom-exception.to-string-tag.js");

require("core-js/modules/es.array-buffer.constructor.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.values.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.concat.js");

require("regenerator-runtime/runtime.js");

var _slicedToArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));

var _defineProperty2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _index = require("@/model/exchange/index");

var _settings = require("@/model/settings");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _menuControlMixin = _interopRequireDefault(require("@/components/common/menuControlMixin.vue"));

var _message = require("@/components/dialog/message");

var _vuex = require("vuex");

var _i18n = require("@/assets/js/i18n");

var _stationSetting = require("@/assets/js/stationSetting");

var _index2 = require("@/model/assets/index");

var _billCenter = require("@/model/ucenter/billCenter");

var _vueCanvasPoster = require("vue-canvas-poster");

var _spreadCenter = require("@/model/ucenter/spreadCenter");

var _b = _interopRequireDefault(require("@/assets/img/siteLogo/b9.png"));

var _mask_new = _interopRequireDefault(require("@/assets/img/siteLogo/mask_new.png"));

var _bxc = _interopRequireDefault(require("@/assets/img/siteLogo/bxc.png"));

var _hx = _interopRequireDefault(require("@/assets/img/siteLogo/hx.png"));

var _logo = _interopRequireDefault(require("@/assets/img/siteLogo/logo100.png"));

var _hxlogo_text = _interopRequireDefault(require("@/assets/img/siteLogo/hxlogo_text.png"));

var _logo100_text = _interopRequireDefault(require("@/assets/img/siteLogo/logo100_text.png"));

var _mask_text = _interopRequireDefault(require("@/assets/img/siteLogo/mask_text.png"));

var _b9_text = _interopRequireDefault(require("@/assets/img/siteLogo/b9_text.png"));

var _qr_code = _interopRequireDefault(require("@/assets/img/qr_code.png"));

var _profit_loss_share_bg = _interopRequireDefault(require("@/assets/img/profit_loss_share_bg.png"));

var _placeholder = _interopRequireDefault(require("@/assets/img/placeholder.png"));

var _expressionBad = _interopRequireDefault(require("@/assets/img/expression/expression-bad.png"));

var _expressionGreat = _interopRequireDefault(require("@/assets/img/expression/expression-great.png"));

var _expressionCool = _interopRequireDefault(require("@/assets/img/expression/expression-cool.png"));

var _orderDetails = _interopRequireDefault(require("./components/orderDetails.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _moment = _interopRequireDefault(require("moment"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import TopTitle from "../../components/Title";
// import { floorNumber, ceilNumber } from "@/assets/js/digital";
// import Socket from "@/assets/js/socket.js";
// import Cookies from "js-cookie";
// import { apiWsUrl } from "@/model/currencyBasedContract/index";
// import {
//   apiAppendInterest,
//   apiSetPositionProfitLoss,
//   apiSetPlanProfitLoss,
//   apiClosePosition,
// } from "@/model/currencyBasedContract/order.js";
// import {
//   apiAppendInterest as apiAppendInterest4U,
//   apiClosePosition as apiClosePosition4U,
//   apiSetPositionProfitLoss as apiSetPositionProfitLoss4U,
//   apiSetPlanProfitLoss as apiSetPlanProfitLoss4U,
// } from "@/model/contractExchange/order.js";
// import InputNumber from "@/components/common/InputNumber";
// import { getAssetsList } from "@/model/assets/index";
// import {
//   timestampToDate,
//   timestampToDay,
//   timestamp,
// } from "@/assets/js/formatDate";
// import BigNumber from "bignumber.js";
var _default = {
  mixins: [_commonMixin.default, _menuControlMixin.default],
  components: {
    NoData: _NoData.default,
    VueCanvasPoster: _vueCanvasPoster.VueCanvasPoster,
    OrderDetails: _orderDetails.default
  },
  data: function data() {
    return {
      placeholder: _placeholder.default,
      wsUrl: "",
      isDestoryWS: false,
      wsContentTime: 0,
      assetsInfo: {
        remain: {
          all_u_valuation: {
            usdt: "--"
          },
          list: []
        }
      },
      marketList: [],
      appendMoneydialog: false,
      staticChainMap: {},
      //静态表1
      staticCurrencyMap: {},
      sotcStaticPaymentMap: {},
      sotcStaticProtectMap: {},
      sotcStaticGuaranteeMap: {},
      copyAccountMsg: "",
      apiAssetsInfo: {},
      from_item_id: "",
      to_item_id: "",
      from_symbol: "",
      to_symbol: "",
      swap_symbol_id: "",
      beforeBailNumber: "",
      afterBailNumber: "",
      beforeLiquidationPrice: "",
      afterLiquidationPrice: "",
      symbolList: {},
      price_precision: "",
      settlement_precision: "",
      contract_value: "",
      fee_rate: "",
      liquidation_risk_rate: "",
      bail_number: "",
      rowData: {},
      row_swap_symbol_id: "",
      inputProfitPrice: "",
      inputLossPrice: "",
      setProfitPricedialog: false,
      dialogType: "",
      confirmMessage: "",
      plan_order_id: "",
      dialogVisible: false,
      profitLossShareBg: _profit_loss_share_bg.default,
      expressionBad: _expressionBad.default,
      expressionCool: _expressionCool.default,
      expressionGreat: _expressionGreat.default,
      notifyImg: "",
      notifyVisible: false,
      painting: {},
      b9Logo: _b.default,
      bxcLogo: _bxc.default,
      hxLogo: _hx.default,
      logo100: _logo.default,
      maskLogo: _mask_new.default,
      hxlogo_text: _hxlogo_text.default,
      logo100_text: _logo100_text.default,
      mask_text: _mask_text.default,
      b9_text: _b9_text.default,
      qrCode: _qr_code.default,
      projectEnglishName: "",
      projectFullName: "",
      slogan: "",
      projectTitle: "",
      projectLogo: "",
      default_invite_code: {},
      centerHost: "",
      operateTypeMap: {
        // 1: "开仓",
        // 2: "平仓",
        // 3: "设置止损价",
        // 4: "设置止盈价",
        // 5: "增加保证金",
        // 6: "已强平",
        // 7: "同时设置止盈止损",
        // 8: "加仓",
        // 9: "减仓",
        // 10: "资金费率",
        1: this.translateTitle("开仓"),
        2: this.translateTitle("平仓"),
        3: this.translateTitle("设置止损价"),
        4: this.translateTitle("设置止盈价"),
        5: this.translateTitle("追加本金"),
        6: this.translateTitle("已强平"),
        7: this.translateTitle("同时设置止盈止损"),
        8: this.translateTitle("加仓"),
        9: this.translateTitle("减仓"),
        10: this.translateTitle("资金费用")
      },
      position_order_id: "",
      position_order_obj: {
        position_info: {},
        operate_list: []
      },
      user_order_obj: {},
      closePositionTypeMap: {
        1: this.translateTitle("未平仓"),
        2: this.translateTitle("用户平仓"),
        3: this.translateTitle("强制平仓"),
        4: this.translateTitle("止盈平仓"),
        5: this.translateTitle("止损平仓"),
        6: this.translateTitle("自动减仓")
      },
      //平仓类型
      openPositionTypeMap: {
        1: this.translateTitle("手动开仓"),
        2: this.translateTitle("触发价开仓")
      },
      //开仓类型
      liquidation_symbol_name: "",
      // 27静态表排除选项
      outerSearch: [5, 6 // 21,
      // 22,
      // 23,
      // 26,
      // 27,
      // 28,
      // 29,
      // 30,
      // 31,
      // 32,
      // 33,
      // 34,
      // 37,
      // 38,
      // 39,
      // 40,
      // 41,
      // 42,
      // 43,
      // 44,
      // 45,
      // 46,
      // 47,
      // 49,
      // 50,
      // 51,
      // 55,
      // 56,
      ],
      coinData: {},
      staticSymbolData: {},
      staticFuturesSymbolData: {},
      searchCoin: [],
      staticAssetsTypeData: [],
      staticStockData: {},
      searchStaticAssetsType: [],
      billStatusMap: [{
        value: 1,
        label: this.translateTitle("进行中")
      }, {
        value: 2,
        label: this.translateTitle("已完成")
      }, {
        value: 3,
        label: this.translateTitle("失败")
      }],
      searchBillStatus: [],
      ctimeAndEtime: [],
      dataList: [],
      opDirectionMap: {
        1: this.translateTitle("收入"),
        2: this.translateTitle("支出")
      },
      tableLoading: true,
      billDialogTitle: "",
      billDialogVisible: false,
      reChargeDialogVisible: false,
      otcDialogVisible: false,
      tabList: [{
        label: this.translateTitle("收款账号"),
        value: 1
      }, {
        label: this.translateTitle("付款截图"),
        value: 2
      }, {
        label: this.translateTitle("订单历史"),
        value: 3
      }],
      currIndex: 1,
      currIndexPosition: 1,
      coinInfoMap: {},
      pageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 10,
        pageCurrent: 1
      },
      isDoBS: false,
      isBuy: true,
      currRow: {}
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.isHideLever) {
                _this.outerSearch = [5, 6, 21, 22, 23, 35, 36, 53, 54];
              }

              _this.getAppIntialDataV2();

              _this.getRebateCommonInfo();

              _this.getStaticChainMap();

              _this.getStaticCurrencyMap();

              _this.getStaticPaymentMap(); // this.getSotcStaticGuaranteeMap();
              // this.getSotcStaticProtectMap();
              // this.getItemList();


              _this.getContractConfigBySymbolId();

              _this.getFuturesConfigBySymbolId();

              _this.getStockConfigBySymbolId();

              _this.getStaticAssetsType();

              _this.getAssets();

              _context.next = 13;
              return _this.getItemList();

            case 13:
              _this.getTotalBills();

              if (_this.language && _stationSetting.VUE_APP_ID == "UhkNBRbpeSGTuaf0yuiG1Yin" || _stationSetting.VUE_APP_ID == "OCzy5RbpeSGTuaf0yuiG1Yin") {
                _this.projectFullName = "Bullxcow";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("Bullxcow App下载");
                _this.projectLogo = _this.bxcLogo;
              } else if (_this.language && _stationSetting.VUE_APP_ID == "9wZvazddcsWrnWtnB7Zhy399") {
                _this.projectFullName = "B9";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("B9 App下载");
                _this.projectLogo = _this.b9Logo;
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "MaskEx") {
                _this.projectFullName = "MaskEX";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("MaskEX App下载");
                _this.projectLogo = _this.maskLogo;
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "100Ex") {
                _this.projectFullName = "100Ex";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("100Ex App下载");
                _this.projectLogo = _this.logo100;
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "EverTrust") {
                _this.projectFullName = "EverTrust";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("EverTrust App下载");
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "8V") {
                _this.projectFullName = "8V";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("8V App下载");
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "UEEx") {
                _this.projectFullName = "UEEx";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("UEEx App");
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "Ahex") {
                _this.projectFullName = "AHEX";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = "AHEX" + _this.translateTitle(" App下载");
              } else if (_this.language && _stationSetting.VUE_UNION_STATION == "5A") {
                _this.projectFullName = "5A";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = "5A" + _this.translateTitle("App下载");
              } else if (_stationSetting.VUE_UNION_STATION == "bitda") {
                _this.projectFullName = "bitda";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = "bitda" + _this.translateTitle("App下载");
              } else if (_stationSetting.VUE_UNION_STATION == "S6") {
                _this.projectFullName = "S6";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u7406\u8D22 \u8D62\u5F97\u672A\u6765");
                _this.projectTitle = "S6" + _this.translateTitle("App下载");
              } else if (_stationSetting.VUE_UNION_STATION == "easy") {
                _this.projectFullName = "ezex";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u7406\u8D22 \u8D62\u5F97\u672A\u6765");
                _this.projectTitle = "ezex" + _this.translateTitle("App下载");
              } else if (_stationSetting.VUE_UNION_STATION == "spex") {
                _this.projectFullName = "SPEX";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u7406\u8D22 \u8D62\u5F97\u672A\u6765");
                _this.projectTitle = "SPEX" + _this.translateTitle("App下载");
              } else {
                _this.projectFullName = "汇信国际";
                _this.slogan = _this.translateTitle("\u6570\u5B57\u8D22\u5BCC \u672A\u6765\u5DF2\u6765");
                _this.projectTitle = _this.translateTitle("汇信App下载");
                _this.projectLogo = _this.hxLogo;
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {},
  beforeDestroy: function beforeDestroy() {},
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language",
    systemCurrency: "user/currency"
  })),
  methods: {
    routeSplicing: _routeSplicing.default,
    translateTitle: _i18n.translateTitle,
    moment: _moment.default,
    goToRecharge: function goToRecharge() {
      window.open(this.routeSplicing(this.language, "ucenter/assets/recharge/usdt"));
    },
    getAssets: function getAssets() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.userInfo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  type: "all"
                };
                _context2.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this2.apiAssetsInfo = data;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getCompleteStatusName: function getCompleteStatusName(assetsType, completeStatus) {
      var closeType = "";

      if ([19, 20, 21, 22, 23, 24, 25, 35, 36, 38].includes(assetsType)) {
        switch (completeStatus) {
          case 1:
            closeType = this.translateTitle("进行中");
            break;

          case 2:
            closeType = this.translateTitle("已完成");
            break;

          case 3:
            closeType = this.translateTitle("已撤销");
            break;

          default:
        } // switch (completeStatus) {
        //     case 1:
        //       closeType = "待成交";
        //       break;
        //     case 2:
        //       closeType = "完全成交";
        //       break;
        //     case 3:
        //       closeType = "已撤销";
        //       break;
        //     case 4:
        //       closeType = "成交失败";
        //       break;
        //     default:
        //   }

      } else if ([5, 6, 8, 9].includes(assetsType)) {
        // } else if ([9].includes(assetsType)) {
        switch (completeStatus) {
          case 1:
            closeType = this.translateTitle("进行中");
            break;

          case 2:
            closeType = this.translateTitle("已完成");
            break;

          case 3:
            closeType = this.translateTitle("已取消");
            break;

          default:
        }
      } else {
        switch (completeStatus) {
          case 1:
            closeType = this.translateTitle("进行中");
            break;

          case 2:
            closeType = this.translateTitle("已完成");
            break;

          case 3:
            closeType = this.translateTitle("失败");
            break;

          default:
        }
      }

      return closeType;
    },
    //Base64 To Blob
    convertBase64ToBlob: function convertBase64ToBlob(base64, type) {
      var imgs = base64.replace(/^data:image\/\w+;base64,/, ""); //去掉base64位头部

      var bytes = window.atob(imgs);
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ab], {
        type: type
      });
    },
    //写入剪切板
    writeClipboard: function writeClipboard(src) {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var blob;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                blob = _this3.convertBase64ToBlob(src, "image/png");
                _context3.next = 4;
                return navigator.clipboard.write([new ClipboardItem((0, _defineProperty2.default)({}, blob.type, blob))]);

              case 4:
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                console.error(_context3.t0.name, _context3.t0.message);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }))();
    },
    //图片生成失败回调函数
    posterFail: function posterFail(err) {
      console.log("fail", err);
    },
    // 复制成功
    copySuccess: function copySuccess() {
      // showMessage({
      //   message: this.translateTitle(`复制成功`),
      //   type: "success",
      // });
      this.$message({
        message: this.translateTitle("\u590D\u5236\u6210\u529F"),
        type: "success",
        customClass: "zZindex"
      });
    },
    // 复制成功
    copyImageSuccess: function copyImageSuccess() {
      // showMessage({
      //   message: this.translateTitle(`图片已复制`),
      //   type: "success",
      // });
      this.$message({
        message: this.translateTitle("\u56FE\u7247\u5DF2\u590D\u5236"),
        type: "success",
        customClass: "zZindex"
      });
    },
    //图片生成成功回调函数
    posterSuccess: function posterSuccess(src) {
      this.notifyImg = src;
      this.notifyVisible = true;
      this.writeClipboard(src);
      this.copyImageSuccess();
    },
    // 复制海报
    createPoster: function createPoster() {
      var _this4 = this;

      setTimeout(function () {
        _this4.billDialogVisible = false;
      }, 1000);
      this.painting = JSON.parse(JSON.stringify(this.poster()));
    },
    poster: function poster() {
      var _this5 = this;

      var sendingAddress = ""; //接收地址

      var receivingAddress = ""; //接收地址

      var arrivalQuantity = this.currRow.item_number + " " + this.currRow.coinItemName; //到账数量

      var orderNum = ""; //订单号

      var orderStatus = this.currRow.child_status_name.toLowerCase() == this.translateTitle("已完成").toLowerCase() || this.currRow.child_status_name.toLowerCase() == this.translateTitle("成功").toLowerCase() ? this.translateTitle("转账成功") : this.translateTitle("转账失败"); //订单状态

      var color = this.currRow.child_status_name.toLowerCase() == this.translateTitle("已完成").toLowerCase() || this.currRow.child_status_name.toLowerCase() == this.translateTitle("成功").toLowerCase() ? "rgb(0 188 160)" : "rgb(240 74 90)";
      var createTime = ""; //创建时间

      var remark = ""; //备注

      var chain = ""; //备注

      var subHeight = 54;
      var subHeightNoSR = 54 + 180;
      this.currRow.detailArray.forEach(function (item) {
        if (item.title == _this5.translateTitle("发送地址")) {
          sendingAddress = item.content ? item.content : "--";
        }

        if (item.title == _this5.translateTitle("接收地址")) {
          receivingAddress = item.content ? item.content : "--";
        }

        if (item.title == _this5.translateTitle("订单号")) {
          orderNum = item.content ? item.content + "" : "--";
        }

        if (item.title == _this5.translateTitle("转账时间")) {
          createTime = item.content ? item.content : "--";
        }

        if (item.title == _this5.translateTitle("备注")) {
          remark = item.content ? item.content : "--";
        }

        if (item.title == _this5.translateTitle("链名称")) {
          chain = item.content;
        }
      });
      var result = {};

      if (chain) {
        result = {
          width: "620px",
          height: "853px",
          background: "#fff",
          views: [{
            type: "image",
            url: this.projectLogo,
            css: {
              top: "31px",
              left: "43px",
              width: "68px",
              height: "68px",
              borderRadius: "100%"
            }
          }, {
            type: "text",
            text: this.projectFullName,
            css: {
              top: "42px",
              left: "130px",
              maxLines: 1,
              fontSize: "33px",
              fontWeight: "600",
              color: "#131f30"
            }
          }, {
            type: "rect",
            css: {
              top: "129px",
              left: "27px",
              color: "#f3f7fc",
              width: "566px",
              height: "557px",
              borderRadius: "4px"
            }
          }, {
            type: "text",
            text: this.translateTitle("链名称"),
            css: {
              top: "165px",
              left: "63px",
              width: "80px",
              maxLines: 2,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: chain,
            css: {
              top: "165px",
              left: "185px",
              width: "300px",
              maxLines: 2,
              fontSize: "21px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: this.translateTitle("发送地址"),
            css: {
              top: "219px",
              left: "63px",
              width: "120px",
              maxLines: 2,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: sendingAddress,
            css: {
              top: "219px",
              left: "185px",
              width: "365px",
              maxLines: 2,
              fontSize: "21px",
              color: "#9aa1b1",
              lineHeight: "36px"
            }
          }, {
            type: "text",
            text: this.translateTitle("接收地址"),
            css: {
              top: "309px",
              left: "63px",
              width: "120px",
              maxLines: 2,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: receivingAddress,
            css: {
              top: "309px",
              left: "185px",
              width: "365px",
              maxLines: 2,
              fontSize: "21px",
              color: "#9aa1b1",
              lineHeight: "36px"
            }
          }, {
            type: "text",
            text: this.translateTitle("到账数量"),
            css: {
              top: "399px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: arrivalQuantity,
            css: {
              top: "399px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              fontWeight: "500",
              color: "#354052" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("订单号"),
            css: {
              top: "453px",
              left: "63px",
              width: "100px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: orderNum,
            css: {
              top: "453px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("订单状态"),
            css: {
              top: "507px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: orderStatus,
            css: {
              top: "507px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: color // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("创建时间"),
            css: {
              top: "561px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: createTime,
            css: {
              top: "561px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("备注"),
            css: {
              top: "615px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: remark,
            css: {
              top: "615px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.projectTitle,
            css: {
              top: "715px",
              left: "54px",
              // width: "200px",
              maxLines: 1,
              fontSize: "29px",
              fontWeight: "600",
              color: "#354052"
            }
          }, {
            type: "text",
            text: this.slogan,
            css: {
              top: "767px",
              left: "54px",
              width: "200px",
              maxLines: 1,
              fontSize: "20.2px",
              color: "#354052" // fontWeight: "300",

            }
          }, {
            type: "qrcode",
            content: this.centerHost + this.default_invite_code.invite_url,
            css: {
              top: "702px",
              right: "54px",
              color: "#000",
              width: "100px",
              height: "100px"
            }
          }]
        };
      } else if (!sendingAddress && !receivingAddress) {
        result = {
          width: "620px",
          height: 783 + 90 - 20 - subHeightNoSR + "px",
          background: "#fff",
          views: [{
            type: "image",
            url: this.projectLogo,
            css: {
              top: "31px",
              left: "43px",
              width: "68px",
              height: "68px",
              borderRadius: "100%"
            }
          }, {
            type: "text",
            text: this.projectFullName,
            css: {
              top: "42px",
              left: "130px",
              maxLines: 1,
              fontSize: "33px",
              fontWeight: "600",
              color: "#131f30"
            }
          }, {
            type: "rect",
            css: {
              top: "129px",
              left: "27px",
              color: "#f3f7fc",
              width: "566px",
              height: 447 + 110 - subHeightNoSR + "px",
              borderRadius: "4px"
            }
          }, // {
          //   type: "text",
          //   text: this.translateTitle("发送地址"),
          //   css: {
          //     top: 219 - subHeightNoSR + "px",
          //     left: "63px",
          //     width: "120px",
          //     maxLines: 2,
          //     fontSize: "25.2px",
          //     color: "#9aa1b1",
          //   },
          // },
          // {
          //   type: "text",
          //   text: sendingAddress,
          //   css: {
          //     top: 219 - subHeightNoSR + "px",
          //     left: "197px",
          //     width: "365px",
          //     maxLines: 2,
          //     fontSize: "25.2px",
          //     color: "#9aa1b1",
          //     lineHeight: "36px",
          //   },
          // },
          // {
          //   type: "text",
          //   text: this.translateTitle("接收地址"),
          //   css: {
          //     top: 219 + 90 - subHeightNoSR + "px",
          //     left: "63px",
          //     width: "120px",
          //     maxLines: 2,
          //     fontSize: "25.2px",
          //     color: "#9aa1b1",
          //   },
          // },
          // {
          //   type: "text",
          //   text: receivingAddress,
          //   css: {
          //     top: 219 + 90 - subHeightNoSR + "px",
          //     left: "197px",
          //     width: "365px",
          //     maxLines: 2,
          //     fontSize: "25.2px",
          //     color: "#9aa1b1",
          //     lineHeight: "36px",
          //   },
          // },
          {
            type: "text",
            text: this.translateTitle("到账数量"),
            css: {
              top: 309 + 90 - subHeightNoSR + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: arrivalQuantity,
            css: {
              top: 309 + 90 - subHeightNoSR + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              fontWeight: "500",
              color: "#354052" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("订单号"),
            css: {
              top: 363 + 90 - subHeightNoSR + "px",
              left: "63px",
              width: "100px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: orderNum,
            css: {
              top: 363 + 90 - subHeightNoSR + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("订单状态"),
            css: {
              top: 417 + 90 - subHeightNoSR + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: orderStatus,
            css: {
              top: 417 + 90 - subHeightNoSR + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: color // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("创建时间"),
            css: {
              top: 471 + 90 - subHeightNoSR + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: createTime,
            css: {
              top: 471 + 90 - subHeightNoSR + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("备注"),
            css: {
              top: 525 + 90 - subHeightNoSR + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: remark,
            css: {
              top: 525 + 90 - subHeightNoSR + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.projectTitle,
            css: {
              top: 645 + 90 - 20 - subHeightNoSR + "px",
              left: "54px",
              // width: "200px",
              maxLines: 1,
              fontSize: "29px",
              fontWeight: "600",
              color: "#354052"
            }
          }, {
            type: "text",
            text: this.slogan,
            css: {
              top: 697 + 90 - 20 - subHeightNoSR + "px",
              left: "54px",
              width: "200px",
              maxLines: 1,
              fontSize: "20.2px",
              color: "#354052" // fontWeight: "300",

            }
          }, {
            type: "qrcode",
            content: this.centerHost + this.default_invite_code.invite_url,
            css: {
              top: 632 + 90 - 20 - subHeightNoSR + "px",
              right: "54px",
              color: "#000",
              width: "100px",
              height: "100px"
            }
          }]
        };
      } else {
        result = {
          width: "620px",
          height: 783 + 90 - 20 - subHeight + "px",
          background: "#fff",
          views: [{
            type: "image",
            url: this.projectLogo,
            css: {
              top: "31px",
              left: "43px",
              width: "68px",
              height: "68px",
              borderRadius: "100%"
            }
          }, {
            type: "text",
            text: this.projectFullName,
            css: {
              top: "42px",
              left: "130px",
              maxLines: 1,
              fontSize: "33px",
              fontWeight: "600",
              color: "#131f30"
            }
          }, {
            type: "rect",
            css: {
              top: "120px",
              left: "27px",
              color: "#f3f7fc",
              width: "566px",
              height: 447 + 110 - subHeight + "px",
              borderRadius: "4px" //*

            }
          }, {
            type: "text",
            text: this.translateTitle("发送地址"),
            css: {
              top: 219 - subHeight + "px",
              left: "63px",
              width: "120px",
              maxLines: 2,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: sendingAddress,
            css: {
              top: 219 - subHeight + "px",
              left: "185px",
              width: "365px",
              maxLines: 2,
              fontSize: "21px",
              color: "#9aa1b1",
              lineHeight: "36px"
            }
          }, {
            type: "text",
            text: this.translateTitle("接收地址"),
            css: {
              top: 219 + 90 - subHeight + "px",
              left: "63px",
              width: "120px",
              maxLines: 2,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: receivingAddress,
            css: {
              top: 219 + 90 - subHeight + "px",
              left: "185px",
              width: "365px",
              maxLines: 2,
              fontSize: "21px",
              color: "#9aa1b1",
              lineHeight: "36px"
            }
          }, {
            type: "text",
            text: this.translateTitle("到账数量"),
            css: {
              top: 309 + 90 - subHeight + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: arrivalQuantity,
            css: {
              top: 309 + 90 - subHeight + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              fontWeight: "500",
              color: "#354052" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("订单号"),
            css: {
              top: 363 + 90 - subHeight + "px",
              left: "63px",
              width: "100px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: orderNum,
            css: {
              top: 363 + 90 - subHeight + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("订单状态"),
            css: {
              top: 417 + 90 - subHeight + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: orderStatus,
            css: {
              top: 417 + 90 - subHeight + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: color // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("创建时间"),
            css: {
              top: 471 + 90 - subHeight + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: createTime,
            css: {
              top: 471 + 90 - subHeight + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.translateTitle("备注"),
            css: {
              top: 525 + 90 - subHeight + "px",
              left: "63px",
              width: "120px",
              maxLines: 1,
              fontSize: "22px",
              color: "#9aa1b1"
            }
          }, {
            type: "text",
            text: remark,
            css: {
              top: 525 + 90 - subHeight + "px",
              left: "185px",
              width: "400px",
              maxLines: 1,
              fontSize: "21px",
              color: "#9aa1b1" // lineHeight: "16px",

            }
          }, {
            type: "text",
            text: this.projectTitle,
            css: {
              top: 645 + 90 - 20 - subHeight + "px",
              left: "54px",
              // width: "200px",
              maxLines: 1,
              fontSize: "29px",
              fontWeight: "600",
              color: "#354052"
            }
          }, {
            type: "text",
            text: this.slogan,
            css: {
              top: 697 + 90 - 20 - subHeight + "px",
              left: "54px",
              width: "200px",
              maxLines: 1,
              fontSize: "20.2px",
              color: "#354052" // fontWeight: "300",

            }
          }, {
            type: "qrcode",
            content: this.centerHost + this.default_invite_code.invite_url,
            css: {
              top: 632 + 90 - 20 - subHeight + "px",
              right: "54px",
              color: "#000",
              width: "100px",
              height: "100px"
            }
          }]
        };
      }

      return result;
    },
    // 复制失败
    copyError: function copyError() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u590D\u5236\u5931\u8D25")
      });
    },
    getItemList: function getItemList() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$getCoinList, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _index2.getStaticCoinList)();

              case 2:
                _yield$getCoinList = _context4.sent;
                status = _yield$getCoinList.status;
                data = _yield$getCoinList.data;

                if (status == 200) {
                  _this6.coinInfoMap = _this6.coinData = data;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    //获取默认邀请码
    getRebateCommonInfo: function getRebateCommonInfo() {
      var _this7 = this;

      (0, _spreadCenter.apiGetRebateCommonInfo)().then(function (res) {
        if (res.status == 200) {
          _this7.default_invite_code = res.data.default_invite_code;
        }
      });
    },
    //获取邀请链接 新
    getAppIntialDataV2: function getAppIntialDataV2() {
      var _this8 = this;

      (0, _spreadCenter.apiGetInviteUrl)().then(function (res) {
        if (res.status == 200) {
          _this8.centerHost = res.data.invite_url;
        }
      });
    },
    //56-static_chain-区块链
    getStaticChainMap: function getStaticChainMap() {
      var _this9 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(56);

              case 2:
                _yield$apiGetStaticTa = _context5.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this9.staticChainMap = Object.values(JSON.parse(JSON.stringify(data)));
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    //7-static_currency-法币表
    getStaticCurrencyMap: function getStaticCurrencyMap() {
      var _this10 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$apiGetStaticTa2, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(7);

              case 2:
                _yield$apiGetStaticTa2 = _context6.sent;
                status = _yield$apiGetStaticTa2.status;
                data = _yield$apiGetStaticTa2.data;

                if (status == 200) {
                  _this10.staticCurrencyMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    //22-sotc_static_payment-支付方式静态表
    getStaticPaymentMap: function getStaticPaymentMap() {
      var _this11 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$apiGetStaticTa3, status, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(22);

              case 2:
                _yield$apiGetStaticTa3 = _context7.sent;
                status = _yield$apiGetStaticTa3.status;
                data = _yield$apiGetStaticTa3.data;

                if (status == 200) {
                  _this11.sotcStaticPaymentMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 保护时间静态表-sotc_static_protect_type-41
    getSotcStaticProtectMap: function getSotcStaticProtectMap() {
      var _this12 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _yield$apiGetStaticTa4, status, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(41);

              case 2:
                _yield$apiGetStaticTa4 = _context8.sent;
                status = _yield$apiGetStaticTa4.status;
                data = _yield$apiGetStaticTa4.data;

                if (status == 200) {
                  _this12.sotcStaticProtectMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 包赔时间静态表 -sotc_static_guarantee_type-42
    getSotcStaticGuaranteeMap: function getSotcStaticGuaranteeMap() {
      var _this13 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _yield$apiGetStaticTa5, status, data;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(42);

              case 2:
                _yield$apiGetStaticTa5 = _context9.sent;
                status = _yield$apiGetStaticTa5.status;
                data = _yield$apiGetStaticTa5.data;

                if (status == 200) {
                  _this13.sotcStaticGuaranteeMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    //根据链名称获取链信息
    getChainByName: function getChainByName(name) {
      var chainObj = {};
      this.staticChainMap.forEach(function (item) {
        if (item.chain_tag == name) {
          chainObj = item;
        }
      });
      return chainObj;
    },
    //U本位合约交易对
    getContractConfigBySymbolId: function getContractConfigBySymbolId() {
      var _this14 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _yield$apiGetStaticTa6, status, data;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa6 = _context10.sent;
                status = _yield$apiGetStaticTa6.status;
                data = _yield$apiGetStaticTa6.data;

                if (status == 200) {
                  _this14.staticSymbolData = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    //币本位合约交易对
    getFuturesConfigBySymbolId: function getFuturesConfigBySymbolId() {
      var _this15 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _yield$apiGetStaticTa7, status, data;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(58);

              case 2:
                _yield$apiGetStaticTa7 = _context11.sent;
                status = _yield$apiGetStaticTa7.status;
                data = _yield$apiGetStaticTa7.data;

                if (status == 200) {
                  _this15.staticFuturesSymbolData = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    //类型
    getStaticAssetsType: function getStaticAssetsType() {
      var _this16 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _yield$apiGetStaticTa8, status, data, tempTypeData;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(27);

              case 2:
                _yield$apiGetStaticTa8 = _context12.sent;
                status = _yield$apiGetStaticTa8.status;
                data = _yield$apiGetStaticTa8.data;

                if (status == 200) {
                  tempTypeData = Object.values(JSON.parse(JSON.stringify(data)));
                  _this16.staticAssetsTypeData = tempTypeData.filter(function (item) {
                    var filterStatus = !_this16.outerSearch.includes(item.assets_type);
                    return filterStatus && item.is_show == 1;
                  });
                }

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    //股票静态表
    getStockConfigBySymbolId: function getStockConfigBySymbolId() {
      var _this17 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var _yield$apiGetStaticTa9, status, data;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(46);

              case 2:
                _yield$apiGetStaticTa9 = _context13.sent;
                status = _yield$apiGetStaticTa9.status;
                data = _yield$apiGetStaticTa9.data;

                if (status == 200) {
                  _this17.staticStockData = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    resetTotalBills: function resetTotalBills() {
      var _arguments = arguments,
          _this18 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var pageNum, defaultSearchStaticAssetsType, tempSearchStaticAssetsTypeArray, req, _yield$apiGetAssetsLo, status, data, tempData;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                pageNum = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                defaultSearchStaticAssetsType = "";
                tempSearchStaticAssetsTypeArray = [];

                _this18.staticAssetsTypeData.forEach(function (item) {
                  tempSearchStaticAssetsTypeArray.push(item.search_id);
                });

                defaultSearchStaticAssetsType = tempSearchStaticAssetsTypeArray.join(",");
                _this18.searchCoin = [];
                _this18.searchStaticAssetsType = [];
                _this18.searchBillStatus = [];
                _this18.ctimeAndEtime = [];
                req = {
                  assets_type_list: defaultSearchStaticAssetsType,
                  page: !isNaN(pageNum) ? pageNum : 1,
                  page_size: _this18.pageInfo.pageSize ? _this18.pageInfo.pageSize : 10
                };
                _this18.tableLoading = true;
                _context14.next = 13;
                return (0, _billCenter.apiGetAssetsLog)(req);

              case 13:
                _yield$apiGetAssetsLo = _context14.sent;
                status = _yield$apiGetAssetsLo.status;
                data = _yield$apiGetAssetsLo.data;

                if (status && status == 200) {
                  tempData = data.list;
                  tempData.forEach(function (item) {
                    item.numberStr = item.item_number + " " + (_this18.coinData[item.item_id] ? _this18.coinData[item.item_id].item_name.toUpperCase() : "未知");
                  });
                  _this18.dataList = _this18.transformListData(JSON.parse(JSON.stringify(tempData)));
                  _this18.pageInfo = JSON.parse(JSON.stringify(data.pageInfo));
                }

                _this18.tableLoading = false;

              case 18:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    getTotalBills: function getTotalBills() {
      var _arguments2 = arguments,
          _this19 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var pageNum, create_time, end_time, _this19$ctimeAndEtime, start, end, end2, defaultSearchStaticAssetsType, tempSearchStaticAssetsTypeArray, req, _yield$apiGetAssetsLo2, status, data, tempData;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                pageNum = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : 1;
                create_time = "";
                end_time = "";

                if (_this19.ctimeAndEtime) {
                  _this19$ctimeAndEtime = (0, _slicedToArray2.default)(_this19.ctimeAndEtime, 2), start = _this19$ctimeAndEtime[0], end = _this19$ctimeAndEtime[1];
                  end2 = end + 86399000;
                  create_time = parseInt(start / 1000);
                  end_time = parseInt(end2 / 1000);
                }

                defaultSearchStaticAssetsType = "";
                tempSearchStaticAssetsTypeArray = [];

                _this19.staticAssetsTypeData.forEach(function (item) {
                  tempSearchStaticAssetsTypeArray.push(item.search_id);
                });

                defaultSearchStaticAssetsType = tempSearchStaticAssetsTypeArray.join(",");
                req = {
                  assets_type_list: _this19.searchStaticAssetsType.join(",") ? _this19.searchStaticAssetsType.join(",") : defaultSearchStaticAssetsType,
                  item_id_list: _this19.searchCoin.join(","),
                  status_list: _this19.searchBillStatus.join(","),
                  create_time: create_time,
                  end_time: end_time,
                  page: !isNaN(pageNum) ? pageNum : 1,
                  page_size: _this19.pageInfo.pageSize ? _this19.pageInfo.pageSize : 10
                };
                _this19.tableLoading = true;
                _context15.next = 12;
                return (0, _billCenter.apiGetAssetsLog)(req);

              case 12:
                _yield$apiGetAssetsLo2 = _context15.sent;
                status = _yield$apiGetAssetsLo2.status;
                data = _yield$apiGetAssetsLo2.data;

                if (status && status == 200) {
                  tempData = data.list;
                  tempData.forEach(function (item) {
                    item.numberStr = item.item_number + " " + (_this19.coinData[item.item_id] ? _this19.coinData[item.item_id].item_name.toUpperCase() : "未知");
                  });
                  _this19.dataList = _this19.transformListData(JSON.parse(JSON.stringify(tempData)));
                  _this19.pageInfo = JSON.parse(JSON.stringify(data.pageInfo));
                }

                _this19.tableLoading = false;

              case 17:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    productInfoClick: function productInfoClick(row) {
      var _this20 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this20.currRow = row; // this.currRow.coinImageUrl =
                //   this.coinData[
                //     this.currRow.item_id == 100001 ? 10132 : this.currRow.item_id
                //   ] &&
                //   this.coinData[
                //     this.currRow.item_id == 100001 ? 10132 : this.currRow.item_id
                //   ].itemDetail.coin_url;

                _this20.currRow.coinImageUrl = _this20.coinData[_this20.currRow.item_id] && _this20.coinData[_this20.currRow.item_id].itemDetail.coin_url;
                _this20.currRow.coinItemName = _this20.coinData[_this20.currRow.item_id] && _this20.coinData[_this20.currRow.item_id].item_name.toUpperCase();

                if ([5, 6, 8, 9].includes(row.assets_type)) {
                  _this20.$refs.orderDetails.productInfoClick(row);
                } else {
                  _this20.billDialogVisible = true;
                }

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }))();
    },
    //请求U本位合约并打开仓位详情
    liquidationContractInfoClick: function liquidationContractInfoClick() {
      var _this21 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                setTimeout(function () {
                  _this21.billDialogVisible = false;
                }, 1000);

                _this21.$refs.orderDetails.liquidationContractInfoClick(_this21.currRow);

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }))();
    },
    //请求币本位合约并打开仓位详情
    liquidationFuturesInfoClick: function liquidationFuturesInfoClick() {
      var _this22 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                setTimeout(function () {
                  _this22.billDialogVisible = false;
                }, 1000);

                _this22.$refs.orderDetails.liquidationFuturesInfoClick(_this22.currRow);

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }))();
    },
    billhandleClose: function billhandleClose(row) {
      this.billDialogVisible = false;
    },
    reChargehandleClose: function reChargehandleClose(row) {
      this.reChargeDialogVisible = false;
    },
    otcHandleClose: function otcHandleClose(row) {
      this.otcDialogVisible = false;
    },
    onAreaChange: function onAreaChange(item) {
      this.currIndex = item.value;
    },
    onPageChange: function onPageChange(val) {
      this.getTotalBills(val);
    },
    openExplor: function openExplor(row) {
      var url = "";

      if (row.order_info.chain_tag) {
        url = this.getChainByName(row.order_info.chain_tag.toLowerCase()).txid_url + row.order_info.txid;
      } else {
        url = this.coinData[row.item_id].itemDetail.txid_url + row.order_info.txid;
      }

      window.open(url);
    },
    transformListData: function transformListData() {
      var _this23 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      list.forEach(function (item) {
        var detailArray = [];
        var detailObj = {
          title: "",
          content: ""
        };

        var coinName = _this23.coinData[item.item_id] && _this23.coinData[item.item_id].item_name.toUpperCase(); // 是否是进账


        var isAssetsIn = item.op_direction == "1"; // 根据类型组装字段开始

        if (item.assets_type == "1" || item.assets_type == "2") {
          var model = item.order_info;
          var transferOrderInfo = model;
          var isOnChainTransfer = model.exchange_type == "2";
          var isChanelTransfer = isOnChainTransfer && model.use_type == "2" && item.assets_type == "2";
          var haveTxid = model.txid ? true : false;

          if (isChanelTransfer) {
            //渠道数字支付
            //转账类型
            detailObj.title = _this23.translateTitle("转账类型");
            detailObj.content = _this23.translateTitle("数字支付");
            detailArray.push(JSON.parse(JSON.stringify(detailObj))); //转账时间

            detailObj.title = _this23.translateTitle("转账时间");
            detailObj.content = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");
            detailArray.push(JSON.parse(JSON.stringify(detailObj))); //接收地址

            if (model.to_address) {
              detailObj.title = _this23.translateTitle("接收地址");
              detailObj.content = model.to_address;
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }
          } else if (isOnChainTransfer) {
            //外部地址
            detailObj.title = _this23.translateTitle(item.show_name) + _this23.translateTitle("类型");
            detailObj.content = _this23.translateTitle("外部地址");
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("创建时间");
            detailObj.content = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");
            detailArray.push(JSON.parse(JSON.stringify(detailObj))); //如果是提币的话，显示到账数量和手续费

            if (item.assets_type == "2") {
              detailObj.title = _this23.translateTitle("到账数量");
              detailObj.content = _this23.handleCutZero(model.num) + " " + coinName;
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
              detailObj.title = _this23.translateTitle("手续费");
              detailObj.content = _this23.handleCutZero(model.network_fee) + " " + coinName;
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }

            if (model.chain_tag) {
              detailObj.title = _this23.translateTitle("链名称");
              detailObj.content = model.chain_tag.toUpperCase();
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }

            detailObj.title = _this23.translateTitle("发送地址");
            detailObj.content = model.from_address;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("接收地址");
            detailObj.content = model.to_address;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));

            if (isOnChainTransfer) {
              detailObj.title = "Txid";
              detailObj.content = model.txid || "--";
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
              detailObj.title = _this23.translateTitle("确认数");
              detailObj.content = _this23.getChainByName(model.chain_tag.toLowerCase()).confirm_num ? "".concat(model.confirm, "/").concat(_this23.getChainByName(model.chain_tag.toLowerCase()).confirm_num) : "".concat(model.confirm, "/").concat(_this23.coinData[item.item_id].itemDetail.confirm_num);
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }
          } else {
            // enablePullDown = true;
            //内部地址
            detailObj.title = _this23.translateTitle(item.show_name) + _this23.translateTitle("类型");
            detailObj.content = _this23.translateTitle("内部地址");
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle(item.show_name) + _this23.translateTitle("时间");
            detailObj.content = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));

            if (model.from_address) {
              detailObj.title = _this23.translateTitle("发送地址");
              detailObj.content = model.from_address;
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }

            if (model.to_address) {
              detailObj.title = _this23.translateTitle("接收地址");
              detailObj.content = model.to_address;
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }

            if (haveTxid) {
              detailObj.title = "Txid";
              detailObj.content = model.txid || "--";
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }
          }

          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = model.uce_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("备注");
          detailObj.content = model.remark || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "3") {
          var _model = item.order_info;

          var time = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("分发类型");
          detailObj.content = item.client_remark;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("分发时间");
          detailObj.content = time;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("备注");
          detailObj.content = _model.bak;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model.id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "4") {
          var _model2 = item.order_info;

          var _time = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var fromItemName = _model2.exchange_item_name ? _model2.exchange_item_name.toUpperCase() : _this23.translateTitle("未知");
          var toItemName = _model2.item_name ? _model2.item_name.toUpperCase() : _this23.translateTitle("未知");
          detailObj.title = _this23.translateTitle("兑换时间");
          detailObj.content = _time;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("兑换花费");
          detailObj.content = "-".concat(_model2.exchange_item_number, " ").concat(fromItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("兑换汇率");
          detailObj.content = "1 ".concat(fromItemName, " \u2248 ").concat(_model2.item_rate, " ").concat(toItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("兑换获得");
          detailObj.content = "+".concat(_model2.item_number, " ").concat(toItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model2.uie_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } // else if (item.assets_type == '5') {
        //   //OTC-买入
        // }else if (item.assets_type == '6') {
        //   //OTC-卖出
        // }
        else if (item.assets_type == "7" || item.assets_type == "12") {
          var _model3 = item.order_info;

          var _time2 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName = _this23.coinData[_model3.from_item_id] ? _this23.coinData[_model3.from_item_id].item_name.toUpperCase() : _this23.translateTitle("未知");

          var _toItemName = _this23.coinData[_model3.to_item_id] ? _this23.coinData[_model3.to_item_id].item_name.toUpperCase() : _this23.translateTitle("未知");

          detailObj.title = _this23.translateTitle("汇兑时间");
          detailObj.content = _time2;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("支付金额");
          detailObj.content = "".concat(_model3.from_number, " ").concat(_fromItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("汇率");
          detailObj.content = "1 ".concat(_fromItemName, " = ").concat(_model3.price, " ").concat(_toItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("得到金额");
          detailObj.content = "".concat(_model3.to_number, " ").concat(_toItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model3.swap_order_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } // else if (item.assets_type == '8') {
        //   //充值
        // }else if (item.assets_type == '9') {
        //   //提现
        // }
        else if (item.assets_type == "10" || item.assets_type == "11") {
          var _model4 = item.order_info;

          var _time3 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle(item.show_name) + _this23.translateTitle("类型");
          detailObj.content = _this23.translateTitle("内部用户");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle(item.show_name) + _this23.translateTitle("时间");
          detailObj.content = _time3;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = isAssetsIn ? _this23.translateTitle("发送用户账号") : _this23.translateTitle("接收用户账号");
          detailObj.content = _model4.obj_user_info ? _model4.obj_user_info : "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("备注");
          detailObj.content = _model4.remark || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model4.transfer_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "13" || item.assets_type == "14" || item.assets_type == "15" || item.assets_type == "16" || item.assets_type == "17" || item.assets_type == "18" || item.assets_type == "48" || item.assets_type == "52") {
          var strs = {
            "13": "发放时间",
            "14": "发放时间",
            "15": "存入时间",
            "16": "存入时间",
            "17": "取出时间",
            "18": "回款时间",
            "48": "购买时间",
            "52": "存入时间"
          };
          var _model5 = item.order_info;

          var _time4 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("类型");
          detailObj.content = item.client_remark;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("存款产品");
          detailObj.content = _model5.remark || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //内部划转

          if (item.assets_type == "48") {
            var baseItemName = _this23.coinData[_model5.base_item_id] ? _this23.coinData[_model5.base_item_id].item_name.toUpperCase() : "";
            detailObj.title = _this23.translateTitle("花费");
            detailObj.content = _model5.base_item_number + baseItemName;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          }

          detailObj.title = strs[item.assets_type];
          detailObj.content = _time4;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model5.ufat_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "19" || item.assets_type == "20") {
          var _model6 = item.order_info;

          var _time5 = _this23.moment(_model6.create_time).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName2 = _this23.coinData[_model6.coin_from] ? _this23.coinData[_model6.coin_from].item_name.toUpperCase() : "";

          var _toItemName2 = _this23.coinData[_model6.coin_to] ? _this23.coinData[_model6.coin_to].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = "".concat(_fromItemName2, "/").concat(_toItemName2);
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //FIXME 增加颜色判断

          detailObj.title = _this23.translateTitle("委托方向");
          detailObj.content = _model6.side == "buy" ? _this23.translateTitle("买入") : _this23.translateTitle("卖出");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托类型");
          detailObj.content = _this23.translateTitle("市价委托");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _model6.side == "buy" ? _this23.translateTitle("买入金额") : _this23.translateTitle("卖出数量");
          detailObj.content = _model6.side == "buy" ? _this23.handleCutZero(_model6.total) + " " + _toItemName2 : _this23.handleCutZero(_model6.num) + " " + _fromItemName2; // : model.the_num + " " + fromItemName;

          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _model6.side == "buy" ? _this23.translateTitle("买入数量") : _this23.translateTitle("卖出金额");
          detailObj.content = _model6.side == "buy" ? _this23.handleCutZero(_model6.deal_num) + " " + _fromItemName2 : _this23.handleCutZero(_model6.total) + " " + _toItemName2;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交均价");
          detailObj.content = _model6.deal_avg_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));

          if (_model6.item_fee != null) {
            detailObj.title = _this23.translateTitle("手续费");
            detailObj.content = _model6.fee + " " + (_model6.side == "buy" ? _fromItemName2 : _toItemName2);
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          }

          detailObj.title = _this23.translateTitle("委托时间");
          detailObj.content = _time5;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model6.trust_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //币币交易
        } else if (item.assets_type == "24" || item.assets_type == "25") {
          var _model7 = item.order_info; // let time = this.moment(model.create_time * 1000).format(
          //   "YYYY-MM-DD HH:mm:ss"
          // );

          var _time6 = _this23.moment(_model7.create_time).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName3 = _this23.coinData[_model7.coin_from] ? _this23.coinData[_model7.coin_from].item_name.toUpperCase() : "";

          var _toItemName3 = _this23.coinData[_model7.coin_to] ? _this23.coinData[_model7.coin_to].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = "".concat(_fromItemName3, "/").concat(_toItemName3);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托方向");
          detailObj.content = _model7.side == "buy" ? _this23.translateTitle("买入") : _this23.translateTitle("卖出");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托类型");
          detailObj.content = _this23.translateTitle("限价委托");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托价格");
          detailObj.content = _model7.price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托量");
          detailObj.content = _model7.num + " " + _fromItemName3; // detailObj.content = model.the_num + fromItemName;

          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托时间");
          detailObj.content = _time6;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); // let updateTime = this.moment(model.update_time * 1000).format(
          //   "YYYY-MM-DD HH:mm:ss"
          // );

          var updateTime = _this23.moment(_model7.update_time).format("YYYY-MM-DD HH:mm:ss");

          if (_model7.status == "2") {
            detailObj.title = _this23.translateTitle("成交时间");
            detailObj.content = updateTime;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交均价");
            detailObj.content = _model7.deal_avg_price;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _model7.side == "buy" ? _this23.translateTitle("买入数量") : _this23.translateTitle("卖出数量");
            detailObj.content = _this23.handleCutZero(_model7.dealNum) + _fromItemName3;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));

            if (_model7.item_fee != null) {
              detailObj.title = _this23.translateTitle("手续费");
              detailObj.content = _model7.fee + " " + (_model7.side == "buy" ? _fromItemName3 : _toItemName3);
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }
          } else if (_model7.status == "3") {
            detailObj.title = _this23.translateTitle("撤销时间");
            detailObj.content = updateTime;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          }

          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model7.trust_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //币币交易 触发价
        } else if (item.assets_type == "21") {
          var _model8 = item.order_info;

          var _time7 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName4 = _this23.coinData[_model8.open_coin_id] ? _this23.coinData[_model8.open_coin_id].item_name.toUpperCase() : "";

          var _toItemName4 = _this23.coinData[_model8.settlement_coin_id] ? _this23.coinData[_model8.settlement_coin_id].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("开仓类型");
          detailObj.content = _model8.open_position_type == "1" ? _this23.translateTitle("市价开仓") : _this23.translateTitle("限价开仓");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓方向");
          detailObj.content = _model8.open_side == "1" ? _this23.translateTitle("买涨") : _this23.translateTitle("买跌");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = "".concat(_fromItemName4, "/").concat(_toItemName4);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("杠杆倍数");
          detailObj.content = _model8.open_leverage + "X";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("本金");
          detailObj.content = _model8.bail_number + " " + _toItemName4;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交均价");
          detailObj.content = _model8.open_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交数量");
          detailObj.content = _model8.open_interest + " " + _fromItemName4;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model8.open_position_fee + " " + _toItemName4;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time7;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model8.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //杠杆交易 开仓
        } else if (item.assets_type == "22") {
          var _model9 = item.order_info; //杠杆交易 平仓

          var closeType = "";

          switch (_model9.close_position_type) {
            case 1:
              closeType = _this23.translateTitle("未平仓");
              break;

            case 2:
              closeType = _this23.translateTitle("用户平仓");
              break;

            case 3:
              closeType = _this23.translateTitle("强制平仓");
              break;

            case 4:
              closeType = _this23.translateTitle("止盈平仓");
              break;

            case 5:
              closeType = _this23.translateTitle("止损平仓");
              break;

            case 6:
              closeType = _this23.translateTitle("自动减仓");
              break;

            default:
          }

          var _time8 = _this23.moment(_model9.close_position_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName5 = _this23.coinData[_model9.open_coin_id] ? _this23.coinData[_model9.open_coin_id].item_name.toUpperCase() : "";

          var _toItemName5 = _this23.coinData[_model9.settlement_coin_id] ? _this23.coinData[_model9.settlement_coin_id].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("平仓类型");
          detailObj.content = closeType;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = "".concat(_fromItemName5, "/").concat(_toItemName5);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓价格");
          detailObj.content = _model9.close_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓数量");
          detailObj.content = _model9.open_interest + " " + _fromItemName5;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓盈亏");
          detailObj.content = _model9.profit_loss + " " + _toItemName5;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓盈亏比");
          detailObj.content = _model9.profit_loss_ratio + "%";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model9.close_position_fee + " " + _toItemName5;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("余额归还");
          detailObj.content = _model9.balance_change_number + " " + _toItemName5;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time8;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model9.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "23") {
          var _model10 = item.order_info;

          var _time9 = _this23.moment(_model10.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName6 = _this23.coinData[_model10.open_coin_id] ? _this23.coinData[_model10.open_coin_id].item_name.toUpperCase() : "";

          var _toItemName6 = _this23.coinData[_model10.settlement_coin_id] ? _this23.coinData[_model10.settlement_coin_id].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("开仓类型");
          detailObj.content = _this23.translateTitle("限价开仓");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓方向");
          detailObj.content = _model10.open_side == "1" ? _this23.translateTitle("买涨") : _this23.translateTitle("买跌");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = "".concat(_fromItemName6, "/").concat(_toItemName6);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("触发条件");
          detailObj.content = _model10.trigger_side == "1" ? "\u2264".concat(_model10.trigger_price) : "\u2265".concat(_model10.trigger_price);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("杠杆倍数");
          detailObj.content = _model10.leverage + "X";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("本金");
          detailObj.content = _model10.bail_number + " " + _toItemName6;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time9;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));

          var triggerTime = _this23.moment(_model10.trigger_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var canncelTime = _this23.moment(_model10.update_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          if (_model10.order_status == "2") {
            detailObj.title = _this23.translateTitle("成交时间");
            detailObj.content = triggerTime;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交均价");
            detailObj.content = _model10.order_price;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交数量");
            detailObj.content = _model10.trade_number + " " + _fromItemName6;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交手续费");
            detailObj.content = _model10.trade_fee + " " + _toItemName6;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          } else if (_model10.order_status == "3") {
            detailObj.title = _this23.translateTitle("撤销时间");
            detailObj.content = canncelTime;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          } else if (_model10.order_status == "4") {
            var reason = "";

            switch (_model10.trigger_fail_type) {
              case 1:
                reason = _this23.translateTitle("超过此交易对最大总持仓数量");
                break;

              case 2:
                reason = _this23.translateTitle("超过账户最大总持仓本金");
                break;

              case 3:
                reason = _this23.translateTitle("超过此交易对最大总持仓本金");
                break;

              default:
            }

            detailObj.title = _this23.translateTitle("成交时间");
            detailObj.content = triggerTime;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("失败原因");
            detailObj.content = reason;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          }

          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model10.plan_order_id;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //杠杆交易 平仓
          // final model = AssetsRecordMarginPlanOrderInfo.fromJson(item.order_info);
          // final fromItemName = StaticTableSerivices.getItems()!.items[model.openCoinId!]?.itemName?.toUpperCase() ?? '';
          // final toItemName = StaticTableSerivices.getItems()!.items[model.settlementCoinId!]?.itemName?.toUpperCase() ?? '';
          // final time = Utils.formatDateMs(Utils.safeParesInt(model.createTime ?? '') * 1000, format: 'yyyy-MM-dd HH:mm:ss');
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('开仓类型'), content: localiseString('限价开仓'), copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('开仓方向'), content: model.openSide == '1' ? localiseString('买涨') : localiseString('买跌'), contentColor: model.openSide == '1' ? HXTheme.currentTheme.greenColor : HXTheme.currentTheme.lightRedColor, copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('交易对'), content: '$fromItemName/$toItemName', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('触发条件'), content: model.triggerSide == '1' ? '≤${model.triggerPrice}' : '≥${model.triggerPrice}', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('杠杆倍数'), content: model.leverage! + 'X', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('本金'), content: model.bailNumber! + ' $toItemName', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('下单时间'), content: time, copyable: true));
          // // final createTime = Utils.formatDateMs(Utils.safeParesInt(model.createTime ?? '') * 1000, format: 'MM/dd HH:mm:ss');
          // final triggerTime = Utils.formatDateMs(Utils.safeParesInt(model.triggerTime ?? '') * 1000, format: 'MM/dd HH:mm:ss');
          // final canncelTime = Utils.formatDateMs(Utils.safeParesInt(model.updateTime ?? '') * 1000, format: 'MM/dd HH:mm:ss');
          // if (model.orderStatus == '2') {
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('成交时间'), content: triggerTime, copyable: true));
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('成交均价'), content: model.orderPrice, copyable: true));
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('成交数量'), content: (model.tradeNumber ?? '') + ' $fromItemName', copyable: true));
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('成交手续费'), content: (model.tradeFee ?? '') + ' $toItemName', copyable: true));
          // } else if (model.orderStatus == '3') {
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('撤销时间'), content: canncelTime, copyable: true));
          // } else if (model.orderStatus == '4') {
          //   String? reason = '';
          //   switch (model.triggerFailType) {
          //     case '1':
          //       reason = localiseString('超过此交易对最大总持仓数量');
          //       break;
          //     case '2':
          //       reason = localiseString('超过账户最大总持仓本金');
          //       break;
          //     case '3':
          //       reason = localiseString('超过此交易对最大总持仓本金');
          //       break;
          //     default:
          //   }
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('成交时间'), content: triggerTime, copyable: true));
          //   infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('失败原因'), content: reason, copyable: true));
          // }
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('订单号'), content: model.planOrderId, copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('平仓数量'), content: (model.openInterest ?? '') + ' $fromItemName', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('平仓盈亏'), content: model.profitLoss + ' $toItemName', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('平仓盈亏比'), content: model.profitLossRatio + '%', copyable: true));
          // infoCells.add(_AssetsRecordDetailInfoCell(title: localiseString('成交手续费'), content: (model.closePositionFee ?? '') + ' $toItemName', copyable: true));
          // if (model.orderStatus == '1') {
          //   bottomButtons = SafeArea(
          //     child: Container(
          //       padding: EdgeInsets.symmetric(horizontal: 15, vertical: 15),
          //       child: Row(
          //         children: <Widget>[
          //           Expanded(
          //             child: SubmitButton(
          //               titleColor: HXTheme.currentTheme.titleColor,
          //               height: 44,
          //               color: Colors.white,
          //               showBorder: true,
          //               borderColor: HXTheme.currentTheme.lightGrayColor,
          //               title: localiseString('撤销'),
          //               onPressed: () async {
          //                 final selection = await UIUtils.showSimpleTitleAlert(context, title: localiseString('是否确认撤销此单？'));
          //                 if (selection == true) {
          //                   try {
          //                     UIUtils.showFullScreenLoading(context);
          //                     await RequestServices.revokePlan(planOrderId: model.planOrderId);
          //                     showToast(localiseString('撤销成功'));
          //                     Global.assetsAllV2Bloc!.fetchAssets();
          //                     ; //更新资产
          //                     Navigator.of(context).pop(); //dismiss loading
          //                     Navigator.of(context).pop(); //pop this
          //                     //刷新资产列表
          //                     eventBus.fire(RefreshRecordListScreen());
          //                     //刷新杠杆持仓
          //                     eventBus.fire(WantRefreshMarginPosition());
          //                   } catch (e) {
          //                     Navigator.of(context).pop(); //dismiss loading
          //                     showToast(e.toString());
          //                   }
          //                 }
          //               },
          //             ),
          //           ),
          //         ],
          //       ),
          //     ),
          //   );
          // }
        } else if (item.assets_type == "26" || item.assets_type == "27" || item.assets_type == "28" || item.assets_type == "29" || item.assets_type == "30" || item.assets_type == "31" || item.assets_type == "32" || item.assets_type == "33" || item.assets_type == "34") {
          var operationTitle = "";
          var fundsTitle = "";
          var timeTitle = ""; //   '26': '借款到账', //借贷
          // '27': '扣除抵押', //借贷
          // '28': '手动结算', //借贷
          // '29': '强平结算', //借贷
          // '30': '部分还款', //借贷
          // '31': '归还抵押', //借贷
          // '32': '全额还款', //借贷
          // '33': '增加抵押', //借贷
          // '34': '减少抵押', //借贷

          switch (item.assets_type) {
            case 34:
              operationTitle = _this23.translateTitle("借款到账");
              fundsTitle = _this23.translateTitle("到账金额");
              timeTitle = _this23.translateTitle("到账时间");
              break;

            case 33:
              operationTitle = _this23.translateTitle("扣除抵押");
              fundsTitle = _this23.translateTitle("扣除数量");
              timeTitle = _this23.translateTitle("扣除时间");
              break;

            case 32:
              operationTitle = _this23.translateTitle("抵押物还款");
              fundsTitle = _this23.translateTitle("归还金额");
              timeTitle = _this23.translateTitle("结算时间");
              break;

            case 31:
              operationTitle = _this23.translateTitle("强平结算");
              fundsTitle = _this23.translateTitle("归还金额");
              timeTitle = _this23.translateTitle("结算时间");
              break;

            case 30:
              operationTitle = _this23.translateTitle("部分还款");
              fundsTitle = _this23.translateTitle("还款金额");
              timeTitle = _this23.translateTitle("还款时间");
              break;

            case 29:
              operationTitle = _this23.translateTitle("归还抵押");
              fundsTitle = _this23.translateTitle("归还数量");
              timeTitle = _this23.translateTitle("归还时间");
              break;

            case 28:
              operationTitle = _this23.translateTitle("全额还款");
              fundsTitle = _this23.translateTitle("还款金额");
              timeTitle = _this23.translateTitle("还款时间");
              break;

            case 27:
              operationTitle = _this23.translateTitle("增加抵押数量");
              fundsTitle = _this23.translateTitle("增加数量");
              timeTitle = _this23.translateTitle("增加时间");
              break;

            case 26:
              operationTitle = _this23.translateTitle("减少抵押数量");
              fundsTitle = _this23.translateTitle("减少数量");
              timeTitle = _this23.translateTitle("减少时间");
              break;

            default:
          }

          var _model11 = item.order_info;

          var _time10 = _this23.moment(_model11.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var coinNumber = _model11.item_number;

          var _coinName = _this23.coinData[_model11.item_id] ? _this23.coinData[_model11.item_id].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("操作类型");
          detailObj.content = operationTitle;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = fundsTitle;
          detailObj.content = coinNumber + " ".concat(_coinName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = timeTitle;
          detailObj.content = _time10;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model11.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); // '借款到账', //借贷
        } else if (item.assets_type == "35") {
          var _model12 = item.order_info;

          var _time11 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName7 = _this23.coinData[_model12.open_item_id] ? _this23.coinData[_model12.open_item_id].item_name.toUpperCase() : "";

          var _toItemName7 = _this23.coinData[_model12.settlement_item_id] ? _this23.coinData[_model12.settlement_item_id].item_name.toUpperCase() : "";

          var config = _this23.staticSymbolData[_model12.symbol_id];
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = config && config.language["symbol_name_".concat(_this23.language)];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓类型");
          detailObj.content = _model12.open_position_type == "1" ? _this23.translateTitle("市价开仓") : _this23.translateTitle("限价开仓");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓方向");
          detailObj.content = _model12.open_side == "1" ? _this23.translateTitle("买涨") : _this23.translateTitle("买跌");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("杠杆倍数");
          detailObj.content = _model12.open_leverage + "X";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("本金");
          detailObj.content = _model12.bail_number + " ".concat(_toItemName7);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交均价");
          detailObj.content = _model12.open_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交数量");
          detailObj.content = _model12.open_interest + " ".concat(_fromItemName7);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model12.open_position_fee + " ".concat(_toItemName7);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time11;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model12.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //合约 开仓
        } else if (item.assets_type == "36") {
          var _model13 = item.order_info; //合约 平仓

          var _closeType = "";

          switch (_model13.close_position_type) {
            case 1:
              _closeType = _this23.translateTitle("未平仓");
              break;

            case 2:
              _closeType = _this23.translateTitle("用户平仓");
              break;

            case 3:
              _closeType = _this23.translateTitle("强制平仓");
              break;

            case 4:
              _closeType = _this23.translateTitle("止盈平仓");
              break;

            case 5:
              _closeType = _this23.translateTitle("止损平仓");
              break;

            case 6:
              _closeType = _this23.translateTitle("自动减仓");
              break;

            default:
          }

          var _time12 = _this23.moment(_model13.close_position_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _fromItemName8 = _this23.coinData[_model13.open_item_id] ? _this23.coinData[_model13.open_item_id].item_name.toUpperCase() : "";

          var _toItemName8 = _this23.coinData[_model13.settlement_item_id] ? _this23.coinData[_model13.settlement_item_id].item_name.toUpperCase() : "";

          var _config = _this23.staticSymbolData[_model13.symbol_id];
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = _config && _config.language["symbol_name_".concat(_this23.language)];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓类型");
          detailObj.content = _closeType;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓价格");
          detailObj.content = _model13.close_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓数量");
          detailObj.content = _model13.open_interest + " ".concat(_fromItemName8);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓盈亏");
          detailObj.content = _model13.profit_loss + " ".concat(_toItemName8);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓盈亏比");
          detailObj.content = _model13.profit_loss_ratio + "%";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model13.close_position_fee + " ".concat(_toItemName8);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("余额归还");
          detailObj.content = _model13.balance_change_number + " ".concat(_toItemName8);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time12;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model13.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "37") {
          var _model14 = item.order_info;

          var _time13 = _this23.moment(_model14.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var stockObj = _this23.staticStockData[_model14.symbol_id] && _this23.staticStockData[_model14.symbol_id].symbol_name;
          var settleItemName = _this23.coinData[_model14.settlement_item_id] ? _this23.coinData[_model14.settlement_item_id].item_name.toUpperCase() : "";
          var stockRegionNameCode = [_this23.staticStockData[_model14.symbol_id] && _this23.staticStockData[_model14.symbol_id].region, _this23.staticStockData[_model14.symbol_id] && _this23.staticStockData[_model14.symbol_id].language["symbol_name_".concat(_this23.language)], _this23.staticStockData[_model14.symbol_id] && _this23.staticStockData[_model14.symbol_id].symbol];
          detailObj.title = _this23.translateTitle("股票"); // detailObj.content = stockObj;

          detailObj.content = stockRegionNameCode;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托方向");
          detailObj.content = _model14.order_type == "1" ? _this23.translateTitle("市价买入") : _this23.translateTitle("限价买入");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("买入数量");
          detailObj.content = _model14.volume + " " + "股";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("扣除保证金");
          detailObj.content = item.item_number + " ".concat(settleItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time13;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model14.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //股票 买入,扣除保证金
        } else if (item.assets_type == "38") {
          var _model15 = item.order_info;

          var ctime = _this23.moment(_model15.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var utime = _this23.moment(_model15.update_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _stockObj = _this23.staticStockData[_model15.symbol_id] && _this23.staticStockData[_model15.symbol_id].symbol_name;

          var feeItemName = _this23.coinData[_model15.fee_item_id] ? _this23.coinData[_model15.fee_item_id].item_name.toUpperCase() : "";

          var _settleItemName = _this23.coinData[_model15.settlement_item_id] ? _this23.coinData[_model15.settlement_item_id].item_name.toUpperCase() : "";

          var _stockRegionNameCode = [_this23.staticStockData[_model15.symbol_id] && _this23.staticStockData[_model15.symbol_id].region, _this23.staticStockData[_model15.symbol_id] && _this23.staticStockData[_model15.symbol_id].language["symbol_name_".concat(_this23.language)], _this23.staticStockData[_model15.symbol_id] && _this23.staticStockData[_model15.symbol_id].symbol];
          detailObj.title = _this23.translateTitle("股票"); // detailObj.content = stockObj;

          detailObj.content = _stockRegionNameCode;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托方向");
          detailObj.content = _model15.order_type == "1" ? _this23.translateTitle("市价买入") : _this23.translateTitle("限价买入");
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //股票 买入
          // 1-进行中|2-待结算|9-已成交|11-撤销中|12-部分待结算|18-部分撤销|19-已撤销
          // String? tradeStatus = '';

          var tradeStatus = "";

          switch (_model15.order_status) {
            case 9:
              tradeStatus = _this23.translateTitle("完全成交");
              break;

            case 18:
              tradeStatus = _this23.translateTitle("部分撤销");
              break;

            case 19:
              tradeStatus = _this23.translateTitle("已撤销");
              break;
          }

          if (tradeStatus != "") {
            detailObj.title = _this23.translateTitle("成交状态");
            detailObj.content = tradeStatus;
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));

            if (_model15.order_status == "19") {
              detailObj.title = _this23.translateTitle("撤销数量");
              detailObj.content = _model15.volume + " " + "股";
              detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            }
          }

          if (_model15.order_status != "19") {
            detailObj.title = _this23.translateTitle("成交数量");
            detailObj.content = _model15.real_volume + " " + "股";
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交均价");
            detailObj.content = (_model15.avg_price ? _model15.avg_price : "--") + " ".concat(_settleItemName);
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交总金额");
            detailObj.content = _model15.real_amount + " ".concat(_settleItemName);
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
            detailObj.title = _this23.translateTitle("成交手续费");
            detailObj.content = _model15.fee_number + " ".concat(feeItemName);
            detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          }

          detailObj.title = _this23.translateTitle("返还保证金");
          detailObj.content = item.item_number + " ".concat(_settleItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = ctime;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _model15.order_status == "19" ? _this23.translateTitle("撤销时间") : _this23.translateTitle("完成时间");
          detailObj.content = utime;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model15.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "39") {
          var _model16 = item.order_info;

          var _ctime = _this23.moment(_model16.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _stockObj2 = _this23.staticStockData[_model16.symbol_id] && _this23.staticStockData[_model16.symbol_id].symbol_name;

          var _feeItemName = _this23.coinData[_model16.fee_item_id] ? _this23.coinData[_model16.fee_item_id].item_name.toUpperCase() : "";

          var _settleItemName2 = _this23.coinData[_model16.settlement_item_id] ? _this23.coinData[_model16.settlement_item_id].item_name.toUpperCase() : "";

          var _stockRegionNameCode2 = [_this23.staticStockData[_model16.symbol_id] && _this23.staticStockData[_model16.symbol_id].region, _this23.staticStockData[_model16.symbol_id] && _this23.staticStockData[_model16.symbol_id].language["symbol_name_".concat(_this23.language)], _this23.staticStockData[_model16.symbol_id] && _this23.staticStockData[_model16.symbol_id].symbol];
          detailObj.title = _this23.translateTitle("股票"); // detailObj.content = stockObj;

          detailObj.content = _stockRegionNameCode2;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("委托方向");
          detailObj.content = _model16.order_type == "1" ? _this23.translateTitle("市价卖出") : _this23.translateTitle("限价卖出");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("卖出价格");
          detailObj.content = _model16.avg_price + " ".concat(_settleItemName2);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("卖出数量");
          detailObj.content = _model16.real_volume + " " + "股";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交总金额");
          detailObj.content = _model16.real_amount + " ".concat(_settleItemName2);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model16.fee_number + " ".concat(_feeItemName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("余额返还");
          detailObj.content = item.item_number + " ".concat(_settleItemName2);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _ctime;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model16.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //股票 买入
        } else if (item.assets_type == "42" || item.assets_type == "43" || item.assets_type == "44" || item.assets_type == "45" || item.assets_type == "46" || item.assets_type == "47") {
          var strs = {
            "46": _this23.translateTitle("发放时间"),
            "47": _this23.translateTitle("发放时间"),
            "42": _this23.translateTitle("存入时间"),
            "43": _this23.translateTitle("存入时间"),
            "44": _this23.translateTitle("取出时间"),
            "45": _this23.translateTitle("回款时间")
          };
          var _model17 = item.order_info;

          var _time14 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("类型");
          detailObj.content = item.client_remark;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("存款产品");
          detailObj.content = _model17.remark || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = strs[item.assets_type];
          detailObj.content = _time14;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model17.udat_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //内部划转
        } else if (item.assets_type == "49" || item.assets_type == "50") {
          var strs = {
            "49": "购买时间",
            "50": "发放时间"
          };
          var _model18 = item.order_info;

          var _time15 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("类型");
          detailObj.content = item.client_remark;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("云矿机产品");
          detailObj.content = _model18.remark || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = strs[item.assets_type];
          detailObj.content = _time15;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model18.ucmat_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //内部划转
        } else if (item.assets_type == "40" || item.assets_type == "41") {
          var strs = {
            "40": _this23.translateTitle("下单时间"),
            "41": _this23.translateTitle("结算时间")
          };

          var _time16 = _this23.moment(item.order_info["create_time"] * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = item.assets_type == "40" ? _this23.translateTitle("下单金额") : _this23.translateTitle("结算金额");
          detailObj.content = "".concat(item.item_number, " ").concat(coinName);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = strs[item.assets_type];
          detailObj.content = _time16;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = item.order_info["game_order_id"];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "53") {
          var _model19 = item.order_info;

          var _time17 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _config2 = _this23.staticFuturesSymbolData[_model19.symbol_id];

          var _fromItemName9 = _this23.coinData[_model19.open_item_id] ? _this23.coinData[_model19.open_item_id].item_name.toUpperCase() : "";

          var _toItemName9 = _this23.coinData[_model19.settlement_item_id] ? _this23.coinData[_model19.settlement_item_id].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = _config2 && _config2.language && _config2.language["symbol_name_".concat(_this23.language)];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓类型");
          detailObj.content = _model19.open_position_type == "1" ? _this23.translateTitle("市价开仓") : _this23.translateTitle("限价开仓");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓方向");
          detailObj.content = _model19.open_side == "1" ? _this23.translateTitle("买涨") : _this23.translateTitle("买跌");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("杠杆倍数");
          detailObj.content = _model19.open_leverage + "X";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("本金");
          detailObj.content = _model19.bail_number + " ".concat(_toItemName9);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交均价");
          detailObj.content = _model19.open_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交数量");
          detailObj.content = _model19.open_interest + " ".concat(_fromItemName9);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model19.fee_consumed + " ".concat(_toItemName9);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time17;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model19.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //合约 开仓
        } else if (item.assets_type == "54") {
          var _model20 = item.order_info; //合约 平仓

          var _closeType2 = "";

          switch (_model20.close_position_type) {
            case 1:
              _closeType2 = _this23.translateTitle("未平仓");
              break;

            case 2:
              _closeType2 = _this23.translateTitle("用户平仓");
              break;

            case 3:
              _closeType2 = _this23.translateTitle("强制平仓");
              break;

            case 4:
              _closeType2 = _this23.translateTitle("止盈平仓");
              break;

            case 5:
              _closeType2 = _this23.translateTitle("止损平仓");
              break;

            case 6:
              _closeType2 = _this23.translateTitle("自动减仓");
              break;

            default:
          }

          var _time18 = _this23.moment(_model20.close_position_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _config3 = _this23.staticFuturesSymbolData[_model20.symbol_id];

          var _fromItemName10 = _this23.coinData[_model20.open_item_id] ? _this23.coinData[_model20.open_item_id].item_name.toUpperCase() : "";

          var _toItemName10 = _this23.coinData[_model20.settlement_item_id] ? _this23.coinData[_model20.settlement_item_id].item_name.toUpperCase() : "";

          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = _config3 && _config3.language && _config3.language["symbol_name_".concat(_this23.language)];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓类型");
          detailObj.content = _closeType2;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓价格");
          detailObj.content = _model20.close_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓数量");
          detailObj.content = _model20.open_interest + " ".concat(_fromItemName10);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓盈亏");
          detailObj.content = _model20.profit_loss + " ".concat(_toItemName10);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓盈亏比");
          detailObj.content = _model20.profit_loss_ratio + "%";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("成交手续费");
          detailObj.content = _model20.fee_consumed + " ".concat(_toItemName10);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("余额归还");
          detailObj.content = _model20.balance_change_number + " ".concat(_toItemName10);
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("下单时间");
          detailObj.content = _time18;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model20.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "55") {
          var _model21 = item.order_info;

          var _time19 = _this23.moment(_model21.operate_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var followMsg = _model21.position_side == "1" ? _this23.translateTitle("\u591A\xB7") + "".concat(_model21.leverage, "X") : _this23.translateTitle("\u7A7A\xB7") + "".concat(_model21.leverage, "X");
          var _config4 = _this23.staticSymbolData[_model21.symbol_id];
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = [_config4.language["symbol_name_".concat(_this23.language)], followMsg];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓均价");
          detailObj.content = _model21.open_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓价格");
          detailObj.content = _model21.close_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("本金");
          detailObj.content = _model21.capital + " USDT";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("合约收益");
          detailObj.content = _model21.profit_loss + " USDT";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("上交收益");
          detailObj.content = _model21.profit_rebate + " USDT";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("交易员");
          detailObj.content = _model21.nick_name;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("上交时间");
          detailObj.content = _time19;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model21.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //上交分润
        } else if (item.assets_type == "56") {
          var _time20 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          var _model22 = item.order_info;

          var _followMsg = _model22.position_side == "1" ? _this23.translateTitle("\u591A\xB7") + "".concat(_model22.leverage, "X") : _this23.translateTitle("\u7A7A\xB7") + "".concat(_model22.leverage, "X");

          var _config5 = _this23.staticSymbolData[_model22.symbol_id];
          detailObj.title = _this23.translateTitle("交易对");
          detailObj.content = [_config5.language["symbol_name_".concat(_this23.language)], _followMsg];
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("开仓均价");
          detailObj.content = _model22.open_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("平仓价格");
          detailObj.content = _model22.close_price;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("本金");
          detailObj.content = _model22.capital + " USDT";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("合约收益");
          detailObj.content = _model22.profit_loss + " USDT";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("接收收益");
          detailObj.content = _model22.profit_rebate + " USDT";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("接收时间");
          detailObj.content = _time20;
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("订单号");
          detailObj.content = _model22.order_no;
          detailArray.push(JSON.parse(JSON.stringify(detailObj))); //接收分润
        } else if (item.assets_type == "57") {
          var _time21 = _this23.moment(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("备注");
          detailObj.content = item.client_remark == _this23.translateTitle("退回红包") || item.client_remark == _this23.translateTitle("发出群红包") ? item.client_remark : _this23.translateTitle("接收红包");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包金额");
          detailObj.content = "".concat(_this23.handleCutZero(item.order_info["total_amount"]), " ").concat(_this23.coinData[item.order_info["settlement_item_id"]].item_name.toUpperCase());
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包数量");
          detailObj.content = "".concat(item.order_info["total_num"], " \u4E2A");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包类型");
          detailObj.content = item.order_info["packet_type"] == "1" ? _this23.translateTitle("拼手气红包") : _this23.translateTitle("普通红包");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("祝福语");
          detailObj.content = item.order_info["content"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("群名称");
          detailObj.content = item.order_info["chat_name"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("发送时间");
          detailObj.content = _time21 || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "58") {
          var _time22 = _this23.moment(item.order_info["grab_time"] * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("备注");
          detailObj.content = item.client_remark == _this23.translateTitle("退回红包") || item.client_remark == _this23.translateTitle("发出群红包") ? item.client_remark : _this23.translateTitle("接收红包");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包金额");
          detailObj.content = "".concat(_this23.handleCutZero(item.order_info["queue_amount"]), " ").concat(_this23.coinData[item.order_info["settlement_item_id"]] && _this23.coinData[item.order_info["settlement_item_id"]].item_name.toUpperCase());
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包类型");
          detailObj.content = item.order_info["packet_type"] == "1" ? _this23.translateTitle("拼手气红包") : _this23.translateTitle("普通红包");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("祝福语");
          detailObj.content = item.order_info["content"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("群名称");
          detailObj.content = item.order_info["chat_name"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("发送人");
          detailObj.content = item.order_info["nick_name"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("领取时间");
          detailObj.content = _time22 || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        } else if (item.assets_type == "59") {
          var finishTime = _this23.moment(item.order_info["finish_time"] * 1000).format("YYYY-MM-DD HH:mm:ss");

          var create_time = _this23.moment(item.order_info["create_time"] * 1000).format("YYYY-MM-DD HH:mm:ss");

          detailObj.title = _this23.translateTitle("备注");
          detailObj.content = item.client_remark == _this23.translateTitle("退回红包") || item.client_remark == _this23.translateTitle("发出群红包") ? item.client_remark : _this23.translateTitle("接收红包");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包金额");
          detailObj.content = "".concat(_this23.handleCutZero(item.order_info["total_amount"]), " ").concat(_this23.coinData[item.order_info["settlement_item_id"]].item_name.toUpperCase());
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("退回金额");
          detailObj.content = "".concat(_this23.handleCutZero(item.order_info["send_back_number"]), " ").concat(_this23.coinData[item.order_info["settlement_item_id"]] && _this23.coinData[item.order_info["settlement_item_id"]].item_name.toUpperCase());
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包数量");
          detailObj.content = "".concat(item.order_info["total_num"], " \u4E2A");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("红包类型");
          detailObj.content = item.order_info["packet_type"] == "1" ? _this23.translateTitle("拼手气红包") : _this23.translateTitle("普通红包");
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("祝福语");
          detailObj.content = item.order_info["content"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("群名称");
          detailObj.content = item.order_info["chat_name"] || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("发送时间");
          detailObj.content = create_time || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
          detailObj.title = _this23.translateTitle("过期时间");
          detailObj.content = finishTime || "--";
          detailArray.push(JSON.parse(JSON.stringify(detailObj)));
        }

        item.detailArray = detailArray; // 根据类型组装字段结束
      });
      return list;
    },
    handleCutZero: function handleCutZero(num) {
      if (!num) return 0; //拷贝一份 返回去掉零的新串

      var newstr = num; //循环变量 小数部分长度
      // console.log(num.indexOf('.') - 1);

      var leng = num.length - num.indexOf(".") - 1; //判断是否有效数

      if (num.indexOf(".") > -1) {
        //循环小数部分
        for (var i = leng; i > 0; i--) {
          //如果newstr末尾有0
          if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
            var k = newstr.lastIndexOf("0"); //如果小数点后只有一个0 去掉小数点

            if (newstr.charAt(k - 1) == ".") {
              return newstr.substring(0, k - 1);
            } else {
              //否则 去掉一个0
              newstr = newstr.substring(0, k);
            }
          } else {
            //如果末尾没有0
            return newstr;
          }
        }
      }

      return num;
    }
  }
};
exports.default = _default;